<div class="main-wrapper">
	<div class="application-section">
		<div *ngIf="showError || notSelected" id="alertMessage" class="alert valign-children-middle">
			<div class="alert-error" role="img" aria-label="Error">
				<i class="icon-badgealert"></i>
			</div>
			<div>
				<span>{{errorMessage}}</span>
			</div>
		</div>
		<section aria-labelledby="applicationsSection" *ngIf="authenticatepage && applicationData.content && !showError">
			<div>
				<h2 tab-index="1" id="applicationsSection" aria-label="Select optional applications">{{applicationData.content.selectOptApp}}</h2>
				<p *ngIf="isDefaultProfile" [innerHTML]="applicationData.content.initialSignup"></p>
				<p *ngIf="!isDefaultProfile" [innerHTML]="applicationData.content.revisedFlow"></p>
			</div>
			<div class="check">
				<div class="checkbox">
					<label for="appSelection">
				<input (change)="onAppPackSelect()"  [checked]="isAppPackageSelected" id="appSelection" type="checkbox"/><i class="skin"></i><span >{{appPackegeTitle}}</span>
			</label>
				</div>
			</div>
			<div class="default-app-names">
				<ul>
					<li class="app-list" *ngFor="let app of defaultAppsName">
						{{app}}
					</li>
				</ul>
				<a *ngIf="isDefaultProfile" target="_blank" href="https://www.business.att.com/solutions/Portfolio/mobility-services/">{{applicationData.content.learnMore}}</a>
			</div>
			<app-accordion [accordion]="appList" [accordionController]=false (click)=removeBottomLine()>
				<app-accordion-list *ngFor="let app of appList; let i = index" [option]='app' [isSubAccordion]=true>
					<app-customgrid [gridOptions]="gridOptions" (onDataChange)="onRowClick($event)"></app-customgrid>
				</app-accordion-list>
			</app-accordion>
	
			<section aria-label="Buttons section" class="buttons-section text-right ">
				<button [disabled]="showError" (click)="continueToNext($event)" class="buttons btn btn-secondary pull-right border-none">{{applicationData.content.buttons.continue}}</button>
				<!-- <a href="#" (click)="continueToNext($event)" class="buttons btn btn-secondary pull-right border-none">{{applicationData.content.buttons.continue}}</a> -->
				<a href="#" (click)="backToPrevious($event)" class="buttons btn btn-link border-none back application-btn-cancel">{{applicationData.content.buttons.back}}</a>
			</section>
			<div *ngIf='showPopup'>
				<app-modal [showModal]="showPopup" [modalClass]="modalClass">
					<app-confirm-modal [modalPopupObject]='appPopup' [triggerElement]='eventEmit' (modalOutput)="closePopup($event)">
					</app-confirm-modal>
				</app-modal>
			</div>
		</section>
	</div>
	</div>
	